import { priceTooltipToggleTpl } from '../priceToggle/priceToggleTpl';

/**
 * Call price block with price-tooltip and button
 * @requires genericAjaxCall
 * @requires datesFromTo
 * @requires priceTooltip
 * @requires cookieManagement
 * @rules We always display the call price : (WPI-38063)
 * - Single-cottage :
 *   - all the time
 * - Multi-cottage :
 *   - if there are dates selected.
 *   - if no date, we just display the CTA "see prices".
 */
export class StartingPrice {
  /**
   * @type {NodeListOf<HTMLElement>}
   */
  container;
  apiData = {};
  /**
   * @type {URLSearchParams}
   */
  ajaxParams = {
    offer: PRODUCT_SCRIPTS.PRODUCT_CODE,
    token: GLOBAL_SCRIPTS.SEARCH_TOKEN,
    sort: 'price',
    language: GLOBAL_SCRIPTS.LANGUAGE_CODE,
    market: GLOBAL_SCRIPTS.MARKET_CODE,
    univers: GLOBAL_SCRIPTS.UNIVERS,
    dateuser: 0,
    currency: GLOBAL_SCRIPTS.CURRENCY_CODE,
    option: {
      relaunchQuery: 0
    }
  };
  displayDateIn = false;
  isMulticottage = false;
  wordingsCommon = GLOBAL_SCRIPTS.WORDINGS_COMMON;
  participants = [{
    senior: 0,
    adult: 2,
    ages: [],
    pet: 0
  }];
  participantsTotal = {
    senior: 0,
    adult: 2,
    children: 0,
    pet: 0,
    total: 0
  };

  constructor() {
    this.container = document.querySelectorAll('.js-starting-price');

    if (this.container.length) {
      this.getData();
    }
  }

  setAjaxParams() {
    let arrivalDate = '';
    let departureDate = '';
    let isFlexPeriod = false;
    let flexZone = '';
    let flexDuration = '';

    // Si cookie storedSearchParams, on récupère les valeurs de ce cookie
    // Si pas de cookie, 2 cas, si il y a des paramètres dans l'url, on applique ces paramètres soit on applique les valeurs par défaut
    const storedSearchParams = JSON.parse(cookieManagement.getCookie('storedSearchParams')) || {};
    const hasStoredSearchParams = !!(Object.keys(storedSearchParams).length);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const today = new Date(new Date().setHours(0, 0, 0, 0));

    if (hasStoredSearchParams) {
      const hasStoredMultiparticipants = Object.keys(storedSearchParams).length && typeof storedSearchParams.multiparticipants !== 'undefined';

      arrivalDate = !!storedSearchParams.date ? storedSearchParams.date[0].value : '';
      departureDate = !!storedSearchParams.dateend ? storedSearchParams.dateend[0].value : '';

      if (arrivalDate && departureDate) {
        this.ajaxParams['dateuser'] = 1;
      }

      if (hasStoredMultiparticipants) {
        this.participants = storedSearchParams.multiparticipants.map(participants => ({
          adult: participants.adult.value,
          ages: participants.ages.map(age => age.value),
          pet: participants.pet.value,
          senior: participants.senior.value
        }));
      }

      if (GLOBAL_SCRIPTS.ABTEST_FLEX_PERIOD === 'B') {
        isFlexPeriod = !!storedSearchParams.isFlexPeriod || false;
        flexZone = storedSearchParams.flexZone ? storedSearchParams.flexZone : '';
        flexDuration = storedSearchParams.duration ? storedSearchParams.duration[0].value : '';
      }
    } else if (urlParams.size > 0) {
      arrivalDate = urlParams.get('facet[DATE]') && new Date(urlParams.get('facet[DATE]')) >= today ? urlParams.get('facet[DATE]') : '';
      departureDate = urlParams.get('facet[DATEEND]') && new Date(urlParams.get('facet[DATEEND]')) >= today ? urlParams.get('facet[DATEEND]') : '';

      this.participants = [{
        senior: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][senior]') || 0),
        adult: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][adult]') || 0),
        ages: (urlParams.getAll('facet[MULTIPARTICIPANTS][0][ages][]') || []),
        pet: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][0][pet]') || 0)
      }];

      if (queryString.indexOf('facet[MULTIPARTICIPANTS][1]') !== -1) {
        this.participants.push({
          senior: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][senior]') || 0),
          adult: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][adult]') || 0),
          ages: (urlParams.getAll('facet[MULTIPARTICIPANTS][1][ages][]') || []),
          pet: parseInt(urlParams.get('facet[MULTIPARTICIPANTS][1][pet]') || 0)
        });
      }

      if (GLOBAL_SCRIPTS.ABTEST_FLEX_PERIOD === 'B') {
        isFlexPeriod = urlParams.get('isFlexPeriod') || '';
        flexZone = urlParams.get('flexZone') || '';
        flexDuration = urlParams.get('facet[DURATIONCP][]') || '';
      }
    }

    this.participants.map((participant) => {
      this.participantsTotal.total += participant.senior || 0;
      this.participantsTotal.total += participant.adult || 0;
      this.participantsTotal.total += participant.ages?.length || 0;

      return this.participantsTotal.total;
    });

    this.ajaxParams['facet[MULTIPARTICIPANTS]'] = this.participants;
    this.ajaxParams['capacity'] = this.participantsTotal.total;

    if (this.participants.length > 1) {
      this.ajaxParams['option[multicottage][nb]'] = 2;
    }

    if (arrivalDate && departureDate) {
      this.ajaxParams['facet[DATE]'] = arrivalDate;
      this.ajaxParams['facet[DATEEND]'] = departureDate;
      this.ajaxParams['duration'] = genericDate.diff(new Date(arrivalDate), new Date(departureDate));
      this.displayDateIn = true;
    }

    if (GLOBAL_SCRIPTS.UNIVERS === 'fba') {
      this.ajaxParams['accreditation'] = GLOBAL_SCRIPTS.ACCREDITATION;
      this.ajaxParams['accreditationGroup'] = GLOBAL_SCRIPTS.ACCREDITATION_GROUP;
      this.ajaxParams['cacheuser'] = GLOBAL_SCRIPTS.CACHE_USER;
    }

    if (GLOBAL_SCRIPTS.ABTEST_FLEX_PERIOD === 'B') {
      this.ajaxParams['isFlexPeriod'] = isFlexPeriod;
      this.ajaxParams['flexZone'] = flexZone;

      if (flexDuration === 'weekend') {
        this.ajaxParams['facet[DURATIONCP][]'] = 2;
        this.ajaxParams['facet[DAYOFWEEKCP]'] = 4;
      } else {
        this.ajaxParams['facet[DURATIONCP][]'] = flexDuration;
      }

      if (isFlexPeriod) {
        this.ajaxParams['option[date_range]'] = 1;
        this.ajaxParams['option[flexholiday]'] = 1;
        this.ajaxParams['dateuser'] = 0;
      }
    }

    this.ajaxParams['option[displayPrice]'] = typeof SEARCH_SCRIPTS.DISPLAY_PRICE !== 'undefined' ? SEARCH_SCRIPTS.DISPLAY_PRICE : 'default';
    this.ajaxParams['option[dispo]'] = 1;
  }

  getData() {
    this.setAjaxParams();

    genericAjaxCall({
      ajaxUrl: `${SEARCH_SCRIPTS.URL_API_BASE}/product/price`,
      ajaxParams: this.ajaxParams,
      successCallback: ({results}) => {
        this.apiData = results.results;
        this.setParticipantsData();
        this.updateProductScripts();
        this.setTrackingData();
        this.showData();
      },
      dataType: 'json',
      type: 'GET'
    });
  }

  showData() {
    const {cache, currency} = this.apiData;
    const {price} = cache;

    if (this.container) {
      const priceTpl = this.getPriceTemplate(
        price.original.value,
        price.promo.value,
        currency.symbol,
        currency.position === 'after'
      );

      this.container.forEach((item) => {
        item.innerHTML = priceTpl;
      });

      this.createTooltip();

      const durationContainer = document.querySelectorAll('.js-starting-duration');
      const dateTpl = this.getDateTemplate();

      durationContainer.forEach((item) => {
        item.innerHTML = dateTpl;
      });

      if (this.hasMulticottage() && !this.displayDateIn) {
        this.hidePrice();
      } else {
        this.showPrice();
      }
    }
  }

  /**
   * Get formatted template
   * @param {number|string} oldPrice
   * @param {number|string} newPrice
   * @param {string} currency
   * @param {boolean} isAfter
   * @return {string}
   */
  getPriceTemplate(oldPrice, newPrice, currency = '€', isAfter = true) {
    const currencyContainer = document.createElement('span');
    currencyContainer.classList.add('priceCurrency');
    currencyContainer.innerHTML = currency;

    const oldPriceContainer = document.createElement('span');
    oldPriceContainer.classList.add('oldPrice');

    const oldPriceValue = document.createElement('span');
    oldPriceValue.textContent = oldPrice.toString();

    if (isAfter) {
      oldPriceContainer.append(oldPriceValue, currencyContainer);
    } else {
      oldPriceContainer.append(currencyContainer, oldPriceValue);
    }

    const newPriceContainer = document.createElement('span');
    newPriceContainer.classList.add('realPrice');

    const newPriceValue = document.createElement('span');
    newPriceValue.textContent = newPrice.toString();
    newPriceValue.setAttribute('itemprop', 'price');

    if (isAfter) {
      newPriceContainer.append(newPriceValue, currencyContainer.cloneNode(true));
    } else {
      newPriceContainer.append(currencyContainer.cloneNode(true), newPriceValue);
    }

    if (newPrice >= oldPrice) {
      return newPriceContainer.outerHTML;
    } else {
      return oldPriceContainer.outerHTML + newPriceContainer.outerHTML;
    }
  }

  createTooltip() {
    const {actionCode, brandCode, cache, housing} = this.apiData;
    const {date, dateEnd, maxPersons, offerCode, price, duration} = cache;
    const labelSuffix = duration === 1 ? this.wordingsCommon.night : this.wordingsCommon.nights;
    const dateLabel = datesFromTo(date, dateEnd, this.wordingsCommon.from_month, this.wordingsCommon.to_month) + ' (' +duration + ' '+labelSuffix+')';
    // get list of services name
    const includedServices = [];

    if (typeof housing.servicesIncludedV2 !== 'undefined' && housing.servicesIncludedV2.length) {
      housing.servicesIncludedV2.forEach((service) => {
        if (service.regroupement === 'PRICEINCLUDE') {
          includedServices.push(service.name.replace(/["']/g, '’'));
        }
      });
    }

    // Get housingLabel
    let housingLabel = housing.housingType.name + ' ' + housing.comfortLevel.name;

    if (housing.specificName !== '') {
      housingLabel = housing.specificName;
    }

    if (housing.isRenovated) {
      housingLabel = housingLabel + ' ' + SEARCH_SCRIPTS.WORDING_RESULT.accommodation_title_renovated;
    }

    // Get discountLabel
    const discountLabel = actionCode.name ? actionCode.name.replace(/["']/g, '’') : '';

    // Fill multicottage from API with participants data
    if (price.multicottage) {
      price.multicottage.map((cottage, i) => {
        cottage.participants = this.participants[i];
        cottage.housingLabel = cottage.housing.specificName.replace(/["']/g, '’');
      });
    }

    const tooltip = document.querySelector('.crossedPrice .js-starting-price-tooltip') || document.querySelector('.crossedPrice .js-priceTooltip-toggle');
    const tooltipTpl = priceTooltipToggleTpl({
      blockClass: 'startingPrice-tooltip',
      trackingGaAction: 'domain banner price tooltip',
      tooltipOptions: {
        typeTooltip: 'domaine',
        includedServices,
        totalParticipants: this.participantsTotal.total,
        participants: price.multicottage ? null : this.participants,
        taxTotal: price.taxTotal,
        originalPrice: price.original.value,
        originalPriceRaw: price.original.raw,
        originalPriceRawBeforeTax: price.original.rawBeforeTax,
        differencePrice: price.difference,
        differencePriceRaw: price.rawDifference,
        petsPrice: price.pets.rawBeforeTax,
        housingLabel: housingLabel.replace(/["']/g, '’'),
        discountLabel,
        dateLabel,
        maxPersons,
        isLikeFancy: true,
        brandCode,
        productCode: offerCode,
        dataMulticottage: price.multicottage ?? []
      }
    });

    if (tooltipTpl) {
      tooltip.outerHTML = tooltipTpl;
    }
  }

  /**
   * Get date label
   * @return {string} - Formated label include date and participants
   * - "For 2 days (3 pers.)"
   * - "From 01 to 24 july (3 pers.)"
   * - "From 24 july to 17 august (3 pers.)"
   * @todo - Update datesFromTo() from shared project to return other formats (without day names or years or short format)
   */
  getDateTemplate() {
    const {cache, startMonth, endMonth} = this.apiData;
    const {date, dateEnd, duration} = cache;
    const totalParticipants = this.participantsTotal.total;

    let label = '';

    if (this.displayDateIn) {
      label = `${this.wordingsCommon.from_month}&nbsp;${new Date(date).toLocaleDateString(undefined, {
        day: 'numeric'
      })}`;

      if (startMonth !== endMonth) {
        label += `&nbsp;${new Date(date).toLocaleDateString(undefined, {
          month: 'short'
        })}`;
      }

      // Show : "Du 12 juillet au 34 aout 2025"
      label += `&nbsp;${this.wordingsCommon.to_month}&nbsp;${new Date(dateEnd).toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'short'
      })}`;
    } else {
      // Show : "Pour 12 nuits"
      label = `${this.wordingsCommon.for}&nbsp;${duration}&nbsp;${this.wordingsCommon.nights}`;
    }

    // Show : "(12 pers.)"
    label += `&nbsp;(${totalParticipants}&nbsp;${this.wordingsCommon.capacity_abrev})`;

    return label;
  }

  setTrackingData() {
    const {uri, actionCode, brandCode, cache, housing} = this.apiData;
    const {price} = cache;

    document.querySelectorAll('.js-starting-button').forEach((button) => {
      button.dataset.urlparams = uri;
    });

    const product_view_item = {
      fromStartingPrice: true,
      actionCode: {
        code: actionCode.code,
        name: actionCode.name
      },
      brand: {
        code: brandCode
      },
      cache: {
        price: {
          original: {
            value: price.original.raw
          },
          promo: {
            value: price.promo.raw
          },
          discount: price.discount
        },
        offerCode: cache.offerCode,
        stock: cache.stock,
        date: cache.date,
        dateEnd: cache.dateEnd
      },
      country: {
        name: PRODUCT_SCRIPTS.COUNTRY,
        code: PRODUCT_SCRIPTS.COUNTRY_CODE
      },
      region: {
        // code: '{{ regionCode }}' // TODO
      },
      destination: {
        // code: '{{ destinationCode }}' // TODO
      },
      offer: {
        name: PRODUCT_SCRIPTS.SITENAME
      },
      additionnal_item_infos: {
        item_seniors_number: this.participantsTotal.senior,
        item_adults_number: this.participantsTotal.adult,
        item_children_number: this.participantsTotal.children,
        // item_children_age: this.participantsTotal.ages, // TODO
        item_pets_number: this.participantsTotal.pet,
        item_number_person: this.participantsTotal.total,
        item_start_date: genericDate.toDisplay(cache.date, 4),
        item_end_date: genericDate.toDisplay(cache.dateEnd, 4)
      }
    };

    if (housing) {
      product_view_item.cache.maxPersons = cache.maxPersons;

      product_view_item.housing = {
        name: housing.name,
        code: housing.code
      };

      if (housing.comfortLevel.name) {
        product_view_item.housing.comfortLevel = {
          name: housing.comfortLevel.name
        };
      }

      if (housing.housingType.name) {
        product_view_item.housing.housingType = {
          name: housing.housingType.name
        };
      }
    }

    window.product_view_item = {
      ...window.product_view_item,
      ...product_view_item,
      DATA_FROM_STARTINGPRICE: true
    };
  }

  updateProductScripts() {
    const {date, duration} = this.apiData.cache;

    if (typeof window.PRODUCT_SCRIPTS !== 'undefined') {
      window.PRODUCT_SCRIPTS = {
        ...window.PRODUCT_SCRIPTS,
        CAPACITY: this.participantsTotal.total,
        START_DATE: date,
        DURATION: duration
      };
    }
  }

  setParticipantsData() {
    const participants = this.participants;

    let participantsTotal = {
      seniors: 0,
      adults: 0,
      children: 0,
      pets: 0,
      total: 0
    };

    // Set total for each cottage
    participants.map((cottage) => {
      return cottage.total = cottage.senior + cottage.adult + cottage.ages.length;
    });

    // Fill total participants object
    for (const cottage of participants) {
      participantsTotal.seniors += cottage.senior || 0;
      participantsTotal.adults += cottage.adult || 0;
      participantsTotal.children += cottage.ages.length || 0;
      participantsTotal.pets += cottage.pet || 0;
      participantsTotal.total += cottage.total || 0;
    }

    this.participantsTotal = participantsTotal;
  }

  hasMulticottage() {
    return this.ajaxParams['facet[MULTIPARTICIPANTS]'].length > 1 || false;
  }

  hidePrice() {
    document.querySelectorAll('.js-starting-loading').forEach((element) => {
      element.classList.add('hide-subNavPrice');
    });
  }

  showPrice() {
    document.querySelectorAll('.js-starting-loading').forEach((element) => {
      element.classList.remove('hide-subNavPrice');
    });
  }
}